import DtoInterface from "./DtoInterface";

export default class CustomerDto implements DtoInterface {
  public id?: number;
  public name?: string;
  public email?: string;
  public phone?: string;
  public document?: string;

  public fromJson(json: any): void {
    this.id = json.id;
    this.name = json.name;
    this.email = json.email;
    this.phone = json.phone;
    this.document = json.document;
  }

  public toJson(): object {
    return {
      name: this.name,
      email: this.email,
      phone: this.phone,
      document: this.document
    };
  }
}